<template>
    <div class="ur-data-grid__edit__calendar" :style="posStyle">
        <!-- [ZONE] Top area -->
        <div class="ur-data-grid__edit__calendar__header">
            <ur-icon-button icon="expand_menu"   borderless @click="onClickPrev"/>
            <!-- [LABEL] Jumper label, keep same as Container's "v-if" order-->
            <div v-show="jumpState === 'Y'">
                <span class="ur-data-grid__edit__calendar__header__jump-label">{{topYearRange}}</span>
            </div>
            <div v-show="jumpState === 'M'">
                <span class="ur-data-grid__edit__calendar__header__jump-label"
                      @click="jumperYear">{{topYear}}</span>
            </div>
            <div v-show="jumpState === 'D'">
                <span class="ur-data-grid__edit__calendar__header__jump-label"
                      @click="jumperMonth">{{topMonthText}}</span>
                <span class="ur-data-grid__edit__calendar__header__jump-label"
                      @click="jumperYear">{{topYear}}</span>
                
            </div>
            <ur-icon-button icon="collapse_menu" borderless @click="onClickNext"/>
        </div>
        <!-- [ZONE] Top area END -->
        <!-- [ZONE] Container area -->
        <!-- [ZONE] Container area, 1. year module -->
        <div class="ur-data-grid__edit__calendar__container
                    ur-data-grid__edit__calendar__container--year" v-show="jumpState === 'Y'">
            <span v-for="y in 10" :key="y"
                  class="ur-data-grid__edit__calendar__cell
                         ur-data-grid__edit__calendar__cell--year"
                  :class="yearClass(y-1+topYearDecade)" @click="onClickYear(y-1+topYearDecade)">{{y-1+topYearDecade}}</span>
        </div>
        <!-- [ZONE] Container area, 2. month module -->
        <div class="ur-data-grid__edit__calendar__container
                    ur-data-grid__edit__calendar__container--month" v-show="jumpState === 'M'">
            <span v-for="m in 12" :key="m+'_'+topYear"
                  class="ur-data-grid__edit__calendar__cell
                         ur-data-grid__edit__calendar__cell--month"
                  :class="monthClass(m-1)" @click="onClickMonth(m-1)">{{m}}</span>
        </div>
        <!-- [ZONE] Container area, 3. Daily picker -->
        <div class="ur-data-grid__edit__calendar__container
                    ur-data-grid__edit__calendar__container--date" v-show="jumpState === 'D'">
            <div class="ur-data-grid__edit__calendar__row
                        ur-data-grid__edit__calendar__row--header">
                <div class="ur-data-grid__edit__calendar__row-content">
                    <span class="ur-data-grid__edit__calendar__week-label"
                          :class="weekDayClass(day.idx)"
                          v-for="(day, idx) in WEEK_DAY" :key="idx">{{day.text}}</span>
                </div>
            </div>
            <div class="ur-data-grid__edit__calendar__date-wrapper">
                <template v-for="(week,wIdx) in calArray">
                    <div :key="wIdx" class="ur-data-grid__edit__calendar__week
                                            ur-data-grid__edit__calendar__row">
                        <div class="ur-data-grid__edit__calendar__row-content">
                            <template v-for="(date) in week">
                                <span class="ur-data-grid__edit__calendar__cell"
                                      :key="date.value.getTime()" :class="dateClass(date)"
                                      @click="onClickDate(date.value)">{{date.text}}</span>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
            <ur-action-bar class="ur-date-picker__action-bar">
                <template v-slot:left>
                    <ur-button tabindex="-1" sm borderless @click.native.stop="onClickToday">{{msgToday}}</ur-button>
                </template>
                <ur-button tabindex="-1" sm main @click.native.stop="onConfirm">{{msgConfirm}}</ur-button>
            </ur-action-bar>
        </div>
    </div>
</template>

<script>
import anchorMixin from "./urDataGridAnchorMixin";
import {textToDate} from "../../util"

const MON_TEXT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const WEEK_DAY = [
    {text:'S', value: 'SUN',idx:0},
    {text:'M', value: 'MON',idx:1},
    {text:'T', value: 'TUE',idx:2},
    {text:'W', value: 'WED',idx:3},
    {text:'T', value: 'THU',idx:4},
    {text:'F', value: 'FRI',idx:5},
    {text:'S', value: 'SAT',idx:6}
];

export default {
    name : 'urDataGridEditDatePickerCalendar',
    mixins : [anchorMixin],
    props : {
        value  : {type: Date},
        rootId : {type:String, default: 'app'},
        format : String,
        minDate: {type: [String, Date]},
        maxDate: {type: [String, Date]},
        
        //-------
        msgToday   : {type:String,default:'Today'},
        msgConfirm : {type:String,default:'Confirm'}
    },
    data() {return {
        currVal : null,
        pageVal : new Date(),
        //----------- 꾸미
        jumpState : 'D', // D > M > Y
    }},
    computed : {
        minDt() {var dt = this.minDate;
            if(!dt) {return null;}
            else if(typeof dt === 'string') {return textToDate(dt, this.format)}
            else {return dt;}
        },
        maxDt() { var dt = this.maxDate;
            if(!dt) {return null;}
            else if(typeof dt === 'string') {return textToDate(dt, this.format)}
            else {return dt;}
        },
        topYear()      {return this.pageVal.getFullYear()},
        topMonth()     {return this.pageVal.getMonth()},
        topMonthText() {return MON_TEXT[this.topMonth]},
        topYearDecade(){return this.topYear - (this.topYear % 10);},
        topYearRange() {return `${this.topYearDecade} ~ ${this.topYearDecade+9}`},
        // [COMPUTED] BIG! 한달의 달력 배열 
        calArray() {
            // 0. prepare value
            // 0.1 global
            var y = this.topYear, m = this.topMonth;
            // 0.2 calc firstDate & day -> start index of loop 
            var firstDay = new Date(y,m);    // First day of this month
            var st = 1-(firstDay.getDay());
            // 0.3 -> last index of loop
            var lastDay = new Date(y,m+1,0); // Last day of this month
            var dayOfMonth = lastDay.getDate();
            var ed = dayOfMonth + firstDay.getDay();
            ed = ed + (7-(ed%7)); // 끝칸 채우기
            // 0.x return value, [[day,...],week,... ]
            var rtn = [], week = [];
            // 1. make array
            for(var i=st, ii=ed; i<=ii ; i++ ) {
                // 1.1 make day item
                var day = new Date(y, m, i);
                var obj = {text: day.getDate(), value : day, state : ''};
                // 1.2 build state
                if(this.minDt && day < this.minDt) {obj.state='disabled'}
                if(this.maxDt && this.maxDt < day) {obj.state='disabled'}
                else if( i<1 )          {obj.state='prev'}
                else if( i>dayOfMonth ) {obj.state='next'}
                // 1.3 append to array
                week.push(obj);
                // 1.4 if week is full? Flush it.
                if(week.length === 7) {
                    rtn.push(week.splice(0));
                }
            }
            return rtn;
        }
    },
    watch : {
        value : {immediate:true, handler(val, old) {
            this.resetValue(val)
        }},
    },
    created() {
        // 0. set Const
        this.WEEK_DAY = WEEK_DAY;
        // 1. check lifecycle
    },
    methods : {
        // [METHODS] for Interface
        // [METHODS] for Events
        onClickPrev()  {
            switch(this.jumpState) {
            case 'D': this.setPageMonth(this.pageVal.getMonth()-1); return;
            case 'M': this.setPageYear (this.pageVal.getFullYear()-1); return;
            case 'Y': this.setPageYear (this.pageVal.getFullYear()-10); return;
            }
        },
        onClickNext()  {
            switch(this.jumpState) {
            case 'D': this.setPageMonth(this.pageVal.getMonth()+1); return;
            case 'M': this.setPageYear (this.pageVal.getFullYear()+1); return;
            case 'Y': this.setPageYear (this.pageVal.getFullYear()+10); return;
            }
        },
        onClickToday() {
            // Make twice, Don't reues TODAY... because It is object;
            this.currVal = getToday();
            this.pageVal = getToday();
        },
        onClickDate(date) {this.currVal = date},
        jumperMonth() {this.jumpState = 'M'},
        jumperYear()  {this.jumpState = 'Y'},
        onClickYear(year) {
            this.pageVal = new Date(year, this.topMonth);
            this.jumpState = 'M'
        },
        onClickMonth(month) {
            this.setPageMonth(month);
            this.jumpState = 'D'
        },
        onConfirm()   {
            this.$emit('input',this.currVal)
        },
        // [METHODS] Logic
        resetValue(val) {
            this.currVal = val;
            this.pageVal = val || new Date();
        },
        setPageMonth(month) { // and it makes reactive works.
            this.pageVal = new Date(this.pageVal.getFullYear(), month);
        }, 
        setPageYear(year) { // and it makes reactive works.
            this.pageVal = new Date(year, this.pageVal.getMonth());
        }, 
        checkOutOfRange(date) {
            return false; // is Safe
        },
        // [METHODS] Styles
        weekDayClass(day) { // day == Date.getDay()
            if(day === 0) return 'ur-data-grid__edit__calendar__cell--sunday';
            if(day === 6) return 'ur-data-grid__edit__calendar__cell--saturday';
            return '';
        },
        dateClass(date) {
            var rtn = [], v = date.value, st = date.state;
            if(isSameDay(v,new Date()))   rtn.push('ur-data-grid__edit__calendar__cell--today');
            if(isSameDay(v,this.currVal)) rtn.push('ur-data-grid__edit__calendar__cell--selected');
            switch(st) {
            case 'disabled' : rtn.push('ur-data-grid__edit__calendar__cell--disabled');    break;
            case 'invisible': rtn.push('ur-data-grid__edit__calendar__cell--invisible');   break;
            case 'next'     : rtn.push('ur-data-grid__edit__calendar__cell--other-month'); break;
            case 'prev'     : rtn.push('ur-data-grid__edit__calendar__cell--other-month'); break;
            }
            rtn.push(this.weekDayClass(v.getDay()));
            return rtn;
        },
        monthClass(m) {
            var rtn = [];
            if(isSameMonth(this.topYear,m,new Date()))   rtn.push('ur-data-grid__edit__calendar__cell--today');
            if(isSameMonth(this.topYear,m,this.currVal)) rtn.push('ur-data-grid__edit__calendar__cell--selected');
            return rtn;
        },
        yearClass(y) {
            var rtn = [];
            if(isSameYear(y,new Date()))   rtn.push('ur-data-grid__edit__calendar__cell--today');
            if(isSameYear(y,this.currVal)) rtn.push('ur-data-grid__edit__calendar__cell--selected');
            return rtn;
        }
    }
}

function getToday() {
    var d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

function isSameDay(v, trg){
    if(!trg) return false;
    return v.getYear()  === trg.getYear()
        && v.getMonth() === trg.getMonth()
        && v.getDate()  === trg.getDate();
}
function isSameMonth(year, month, trg){
    if(!trg) return false;
    return year  === trg.getFullYear()
        && month === trg.getMonth();
}
function isSameYear(year, trg){
    if(!trg) return false;
    return year  === trg.getFullYear();
}
</script>